<template>
  <div>
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="content_box">
      <el-row style="margin:5px 0">
        <el-button size="mini" class="btn" type="primary" @click="onSave" v-acl="QUALITY_DEFECT_SAVE">保存</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onSubmit('submit')"
          v-acl="QUALITY_DEFECT_SUBMIT">提交</el-button>
        <el-button size="mini" class="btn" type="primary" @click="stinvUrl"
          v-if="detailForm.stinvLink">STINV链接</el-button>
      </el-row>
      <div class="within_box">
        <div class="title_box">
          <p class="line"></p>
          <p class="title">Case Detail</p>
        </div>
        <div class="form_box">
          <el-form :model="detailForm" ref="detailForm" :rules="rules" label-width="100px">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="主动报废编号" prop="sroCode">
                  <el-input v-model="detailForm.sroCode" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="报废启动日期" prop="startDate">
                  <el-date-picker v-model="detailForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择"
                    style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="报废项目简介" prop="projectSummary">
                  <el-input v-model="detailForm.projectSummary" style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="已结案" prop="isClosed">
                  <el-select v-model="detailForm.isClosed" disabled placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item, index) in isClosedLists" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="SR等级" prop="grade">
                  <ic-select table="TT_QUALITY_DEFECT" field="GRADE" v-model="detailForm.grade"
                    style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="发起人" prop="creator">
                  <el-input v-model="detailForm.creator" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态" prop="status">
                  <ic-select disabled table="TT_QUALITY_DEFECT" field="STATUS" v-model="detailForm.status"
                    style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="原因" prop="reason">
                  <el-input v-model="detailForm.reason" type="textarea" maxlength="1000" show-word-limit
                    :autosize="{ minRows: 4, maxRows: 6 }" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注" prop="remarks">
                  <el-input v-model="detailForm.remarks" type="textarea" maxlength="1000" show-word-limit
                    :autosize="{ minRows: 4, maxRows: 6 }" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="是否下发成功" prop="isIssued">
                  <el-input v-model="detailForm.isIssued" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="下发时间" prop="issueDate">
                  <el-input v-model="detailForm.issueDate" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="tab_box">
        <el-tabs type="border-card" v-model="activeName">
          <el-tab-pane label="产品明细" name="tab1" class="setLength">
            <el-row style="margin-bottom:5px">
              <el-button size="mini" class="btn" type="primary" @click="onAdd">新增</el-button>
              <el-button size="mini" class="btn" type="danger" @click="onDel('Save')">删除</el-button>
              <el-button size="mini" class="btn" type="primary" @click="onCopy('Save')">复制行</el-button>
            </el-row>
            <ux-grid ref="plxTable1" :data="tabData1" @selection-change="selectionChange" keep-source max-height="500"
              show-overflow="tooltip" highlight-current-row>
              <ux-table-column align="center" type="checkbox" width="80" />
              <ux-table-column align="center" title="操作" width="80">
                <template v-slot="scope">
                  <el-button type="text" @click="onModify(scope.row, scope)">编辑</el-button>
                </template>
              </ux-table-column>
              <ux-table-column align="center" title="序号" type="index" width="60" />
              <ux-table-column align="center" title="产品编号" field="eightBitCode" min-width="100"></ux-table-column>
              <ux-table-column align="center" title="产品名称" field="eightBitCodeName" min-width="100"></ux-table-column>
              <ux-table-column align="center" title="结算单位名称" field="supplierName" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="Facility名称" field="facilityName" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="包装类型" field="packType" min-width="120">
                <template v-slot="scope">
                  {{ scope.row.packType | ic('TT_QUALITY_DEFECT', 'PACK_TYPE') }}
                </template>
              </ux-table-column>
              <ux-table-column align="center" title="生产日期" field="madeDate" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="批次号" field="batchNo" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="DCs" field="dcCode" min-width="120">
                <template v-slot="scope">
                  <div class="newDcs">
                    {{ scope.row.dcCode | dcsFilter }}
                  </div>
                </template>
              </ux-table-column>
              <ux-table-column align="center" title="Markets" field="marketName" min-width="120">
                <template v-slot="scope">
                  <div class="newDcs">
                    {{ scope.row.marketName | dcsFilter }}
                  </div>
                </template>
              </ux-table-column>
              <ux-table-column align="center" title="报废范围" field="disposalScope" min-width="120">
                <template v-slot="scope">
                  {{ scope.row.disposalScope | ic('TT_QUALITY_DEFECT', 'DISPOSAL_SCOPE') }}
                </template>
              </ux-table-column>
              <ux-table-column align="center" title="餐厅报废数量(箱)" field="storeDisposalQty"
                min-width="150"></ux-table-column>
              <ux-table-column align="center" title="DC报废数量(箱)" field="dcDisposalQty" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="报废数量(箱)" field="disposalQty" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="处理结果" field="handlingResult" min-width="120">
                <template v-slot="scope">
                  {{ scope.row.handlingResult | ic('TT_QUALITY_DEFECT', 'HANDLING_RESULT') }}
                </template>
              </ux-table-column>
            </ux-grid>
          </el-tab-pane>
          <el-tab-pane label="门店报废统计" name="tab2">
            <!-- <el-row style="margin-bottom:5px">
              <el-button size="mini" class="btn" type="primary" @click="onAdd('Save')">新增</el-button>
              <el-button size="mini" class="btn" type="danger" @click="onDel('Save')">删除</el-button>
              <el-button size="mini" class="btn" type="primary" @click="onCopy('Save')">复制行</el-button>
            </el-row> -->
            <el-table ref="plxTable1" :data="tabData2" @selection-change="selectionChange" keep-source max-height="500"
              show-overflow="tooltip" highlight-current-row>
              <el-table-column align="center" type="checkbox" width="80" />
              <el-table-column align="center" label="序号" type="index" width="60" />
              <el-table-column align="center" label="产品编号" prop="eightBitCode"></el-table-column>
              <el-table-column align="center" label="产品名称" prop="eightBitCodeName"></el-table-column>
              <el-table-column align="center" label="生产日期" prop="madeDate"></el-table-column>
              <el-table-column align="center" label="批次号" prop="batchNo"></el-table-column>
              <el-table-column align="center" label="DC" prop="dcCode">
              </el-table-column>
              <el-table-column align="center" label="涉及Markets" prop="marketName"></el-table-column>
              <el-table-column align="center" label="报废数量(箱)" prop="disposalQty"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="附件上传" name="tab3">
            <el-row style="margin-bottom:5px">
              <el-button size="mini" class="btn" type="primary" @click="onUpload">上传</el-button>
            </el-row>
            <el-table ref="plxTable2" :data="tabData3" max-height="500" border highlight-current-row>
              <el-table-column align="center" label="操作" width="80">
                <template slot-scope="scope">
                  <el-button type="text" @click="delFile(scope.row, scope.$index)">删除</el-button>
                </template>
              </el-table-column>

              <el-table-column align="center" label="附件名称" prop="documentName" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button type="text" @click="onDownload(scope.row, scope.$index)">{{ scope.row.documentName
                  }}</el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" label="附件描述" prop="docComments" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" label="上传人" prop="userName" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" label="上传时间" prop="createDate" show-overflow-tooltip></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="操作日志" name="tab4">
            <el-table ref="plxTable3" :data="tabData4" max-height="500" highlight-current-row>
              <el-table-column align="center" label="操作时间" prop="createDate"></el-table-column>
              <el-table-column align="center" label="操作人" prop="operatorName"></el-table-column>
              <el-table-column align="center" label="操作描述" prop="action"></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog title="产品明细" :visible.sync="dialogEditVisible" width="80%" @close="onCancel">
      <el-form :model="editForm" ref="editFormDialog" v-if="dialogEditVisible">
        <el-table :data="editForm.editData" ref="editDataRef" border highlight-current-row class="stockRecovery_table">
          <el-table-column show-overflow-tooltip prop="eightBitCode" label="产品编号"></el-table-column>
          <el-table-column show-overflow-tooltip prop="eightBitCodeName" label="产品名称"></el-table-column>
          <el-table-column show-overflow-tooltip prop="supplierName" label="结算单位名称"></el-table-column>
          <el-table-column show-overflow-tooltip prop="facilityName" label="Facility名称"></el-table-column>
          <el-table-column prop="packType" label="包装类型">
            <template slot-scope="scope">
              <el-form-item :prop="`editData.${scope.$index}.packType`" :rules="packTypeRules(scope.$index, scope.row)">
                <ic-select table="TT_QUALITY_DEFECT" field="PACK_TYPE" v-model="scope.row.packType"
                  style="width:100%"></ic-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="madeDate" label="生产日期">
            <template slot-scope="scope">
              <el-form-item :prop="`editData.${scope.$index}.madeDate`" :rules="madeDateRules(scope.$index, scope.row)">
                <el-date-picker v-model="scope.row.madeDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择"
                  style="width:100%"></el-date-picker>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="batchNo" label="批次号">
            <template slot-scope="scope">
              <el-button type="text" @click="clickBatch(scope.row)">列表维护</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="disposalScope" label="报废范围">
            <template slot-scope="scope">
              <el-form-item :prop="`editData.${scope.$index}.disposalScope`"
                :rules="disposalScopeRules(scope.$index, scope.row)">
                <ic-select table="TT_QUALITY_DEFECT" field="DISPOSAL_SCOPE"
                  @change="recoveryScopeChange(scope.row, $event)" v-model="scope.row.disposalScope"
                  style="width:100%"></ic-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="storeDisposalQty" label="餐厅报废数量(箱)" min-width="120">
            <template slot-scope="scope">
              <el-form-item :prop="`editData.${scope.$index}.restaurantRecoveryQty`"
                :rules="restaurantRecoveryQtyRules(scope.$index, scope.row)">
                <el-input v-model="scope.row.storeDisposalQty" disabled></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="dcDisposalQty" label="DC报废数量(箱)">
            <template slot-scope="scope">
              <el-form-item :prop="`editData.${scope.$index}.dcDisposalQty`"
                :rules="scope.row.disposalScope == 'DC' || scope.row.disposalScope == 'DCAndRestaurant' ? dcDisposalQtyRules(scope.$index, scope.row) : ''">
                <el-input :disabled="scope.row.disposalScope == 'Restaurant' ? true : false"
                  v-model="scope.row.dcDisposalQty" @blur="getDisposalQty(scope.row)"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="disposalQty" label="报废数量(箱)">
          </el-table-column>
          <el-table-column prop="handlingResult" label="处理结果" :render-header="renderHeader">
            <template slot-scope="scope">
              <el-form-item :prop="`editData.${scope.$index}.handlingResult`">
                <ic-select table="TT_QUALITY_DEFECT" field="HANDLING_RESULT" v-model="scope.row.handlingResult"
                  style="width:100%"></ic-select>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <el-row type="flex" justify="center" style="margin-top:10px;">
        <el-button type="primary" @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onConfirm">确认</el-button>
      </el-row>
    </el-dialog>
    <el-dialog title="附件上传" :visible.sync="dialogUploadVisible" width="50%" @close="onClose">
      <el-form :model="uploadForm" v-if="dialogUploadVisible" ref="uploadForm" :rules="rules" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="附件描述" prop="docComments">
              <el-input v-model="uploadForm.docComments"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="附件名称" prop="fileName">
              <el-input v-model="uploadForm.fileName" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!-- <el-upload ref="upload" :headers="header" action="" :http-request="httpRequest" :on-change="handleChange"
              :before-upload="beforeUpload" :file-list="fileList" :limit="1" :auto-upload="false" :show-file-list="false">
              <el-button size="small" type="primary">选取文件</el-button>
            </el-upload> -->
            <el-upload ref="upload" name="file" :on-change="handleChange" action="" :http-request="httpRequest" :limit="1"
              :show-file-list="false">
              <el-button size="small" type="primary">选取文件</el-button>
            </el-upload>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-button size="small" type="primary" @click="submitUpload">上传</el-button>
          <el-button size="small" type="primary" @click="onCloseFileDialog">关闭</el-button>
        </el-row>
      </el-form>
    </el-dialog>


    <el-dialog title="批次号维护" :visible.sync="batchVisible" width="40%" @close="onCancel1">
      <el-form :model="editForm" ref="editForm" v-if="batchVisible">
        <el-row type="flex" justify="center">
          <el-col :span="12" class="rowCenter">显示</el-col>
          <el-col :span="12" class="rowCenter">
            <el-select v-model="batchShowStatus" placeholder="请选择">
              <el-option v-for="item in batchOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-table :data="batchList" ref="editDataRef" border highlight-current-row class="stockRecovery_table">
          <el-table-column show-overflow-tooltip prop="eightBitCode" label="产品编号">
            <template slot="header">
              <el-button type="text" @click="addBatch">新增</el-button>
            </template>
            <template slot-scope="scope">
              <el-button type="text" style="color:red;" @click="delBatch(scope.row, scope.$index)">删除</el-button>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="batchNo" label="批次号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.batchNo" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <el-row type="flex" justify="center" style="margin-top:10px;">
        <el-button type="primary" @click="onCancel1">取消</el-button>
        <el-button type="primary" @click="onConfirm1">保存</el-button>
      </el-row>
    </el-dialog>


    <el-dialog title="产品名称选择" :visible.sync="dialogProVisible" width="80%" @close="onClosePro">
      <selProDialog @setSelPro="setSelPro"></selProDialog>
    </el-dialog>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import StockRecoveryApi from "@/api/StockRecovery/index";
import commonConstants from "@/constants/commonConstants";
import selProDialog from "./selProName.vue"
import { fileService } from "@/api/common/file-utils";
import store from "@/store";
export default {
  components: {
    IcSelect,
    selProDialog
  },
  data() {
    let validRecoveryProjectSummary = (rule, value, callback) => {
      if (!value) {
        this.$my_message('请输入回收项目简介', 'error')
        callback(new Error(' '));
      } else {
        var reg = /^.{1,100}$/
        if (!reg.test(value)) {
          this.$my_message('字段“回收项目简介”已超出数据库长度要求（长度：100），请删减.', 'error')
          callback(new Error(' '));
        } else {
          callback();
        }
      }
    };
    return {
      uploadUrl: "",
      batchList: [],
      batchShowStatus: "0",
      activeName: "tab1",
      index: null,
      negativeIndex: -1,
      ttQualityDefectId: this.$route.query.ttQualityDefectId,
      dialogEditVisible: false,
      dialogUploadVisible: false,
      dialogProVisible: false,
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      rules: {
        startDate: [
          { required: true, message: '请选择报废启动日期', trigger: 'change' },
        ],
        projectSummary: [
          { required: true, message: '请输入报废项目简介', trigger: 'blur' },
        ],
        recoveryProjectSummary: [
          { required: true, validator: validRecoveryProjectSummary, trigger: 'blur' },
        ],
        grade: [
          { required: true, message: '请选择SR等级', trigger: 'change' },
        ],
        // reason: [
        //   { required: true, message: '请输入原因', trigger: 'blur' },
        // ]
      },
      uploadForm: {
        fileName: "",
        files: [],
      },
      detailForm: {
        sroCode: "",
        startDate: "",
        projectSummary: "",
        isClosed: "N",
        grade: "C",
        createBy: "",
        status: "Draft",
        reason: "",
        remarks: "",
        isIssued: "",
        issueDate: "",
      },
      batchVisible: false,
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tabData1: [],
      tabData2: [],
      tabData3: [],
      tabData4: [],
      editForm: {
        editData: [{
          packType: "outer",
        }]
      },
      fileList: [],
      batchOptions: [{
        label: "合并一行显示",
        value: "0",
      }, {
        label: "拆分显示",
        value: "1",
      }],
      isClosedLists: [
        {
          label: "Y",
          value: "Y",
        },
        {
          label: "N",
          value: "N",
        }
      ],
      srGradeLists: [
        {
          label: "A",
          value: "A",
        },
        {
          label: "B",
          value: "B",
        },
        {
          label: "C",
          value: "C",
        },
        {
          label: "D",
          value: "D",
        }
      ],
      relatedDcCodeLists: [],
      attachmentLargeCategoryLists: [],
      attachmentSmallCategoryLists: [],
      multipleSelection: [],
      ttQspiStockRecItemIdLists: [],
      productNum: 0,
    }
  },
  watch: {

  },
  filters: {
    dcsFilter(dcIdsStr) {
      var reg = /[;]/g;
      var reg1 = /[' ']/g;
      if (reg.test(dcIdsStr)) {
        console.log("测试数据====", dcIdsStr.split(';').join(' ').replace(reg1, "$&\r\n"))
        // return dcIdsStr = dcIdsStr.replace(reg, "$&\r\n");  // ‘$&’替换与regexp相匹配的子串
        return dcIdsStr = dcIdsStr.split(';').join(' ').replace(reg1, "$&\r\n");  // ‘$&’替换与regexp相匹配的子串
      } else {
        return dcIdsStr
      }
    }
  },
  computed: {
    // uploadUrl() {
    //   return commonConstants.fileUploadUrl;
    // }
  },
  created() {

  },
  mounted() {
    if (this.$route.query.from === 'edit') {
      this.getDetailInfo(this.ttQualityDefectId)
      // this.getHeaderInfo()
      // this.getTableInfo()
      // this.getAttachmentsLists()
      // this.getOperateLogs()
    }
    // this.getAllAcitveQspiDc()
    // this.getAttachmentLargeLists()
  },
  methods: {
    getDetailInfo(id) {
      StockRecoveryApi.qualityDefectDetail(id).then(res => {
        this.detailForm = res.data
        this.tabData1 = res.data.details
        this.tabData2 = res.data.storeDisposals
        this.tabData3 = res.data.documents
        this.tabData4 = res.data.auditLogList
      });
    },
    getHeaderInfo() {
      StockRecoveryApi.qualityDefectDetail(this.ttQualityDefectId).then(res => {
        this.detailForm = res.data
      });
    },
    getTableInfo() {
      StockRecoveryApi.getItemsByHeaderId(this.ttQualityDefectId).then(res => {
        console.log('res', res);
        this.tableData1 = res.data
        this.$refs.plxTable1.reloadData(res.data)
      });
    },
    handlingResultChange(val, index, editData) {
      var str = []
      if (val.length > 0) {
        val.forEach(ele => {
          str.push(store.state.main.inputChoiceDec['TT_QSPI_STOCK_REC_ITEM']['HANDLING_RESULT'][ele].value)
        })
        editData[index].handlingResult = val
        editData[index].handlingResultI18n = str.join(',')
      }
      console.log('editData', editData);
    },
    getAllAcitveQspiDc() {
      StockRecoveryApi.getAllAcitveQspiDc().then(res => {
        console.log('获取dcs', res);
        this.relatedDcCodeLists = res.data
      });
    },
    getAttachmentsLists() {
      StockRecoveryApi.getAttachmentsByHeaderId(this.ttQualityDefectId).then(res => {
        console.log('获取文件', res);
        this.tableData2 = res.data
      });
    },
    getOperateLogs() {
      StockRecoveryApi.getOperateLogsByHeaderId(this.ttQualityDefectId).then(res => {
        console.log('获取操作日志', res);
        this.tableData3 = res.data
      });
    },
    getAttachLargeCategoryList() {
      StockRecoveryApi.getAttachLargeCategoryList(this.ttQualityDefectId).then(res => {
        console.log('获取附件大类', res);
        this.tableData3 = res.data
      });
    },
    getAttachmentLargeLists() {
      StockRecoveryApi.getAttachLargeCategoryList().then(res => {
        console.log('获取附件大类', res);
        this.attachmentLargeCategoryLists = res.data
      });
    },
    attachmentLargeCategoryChange(val) {
      console.log('val', val);
      this.uploadForm.attachmentSmallCategory = ''
      this.getAttachmentSmallLists(val)
    },
    getAttachmentSmallLists(val) {
      StockRecoveryApi.getAttachSmallCategoryListByLargeCategory(val).then(res => {
        console.log('获取附件小类', res);
        this.attachmentSmallCategoryLists = res.data
        if (val == 'McD’s China internal communication') {
          this.uploadForm.attachmentSmallCategory = 'Stock recovery effective statement'
        }
        if (val == 'DC Stock recovery and return summary') {
          this.uploadForm.attachmentSmallCategory = 'Stock recovery and return summary'
        }
      });
    },
    clickBatch(row) {
      this.batchList = []
      console.log("this.editForm.editData[0].batchNo", this.editForm.editData[0].batchNo)
      if (this.editForm.editData[0].batchNo) {
        if (this.editForm.editData[0].batchNo.indexOf(';')) {   //判断是合并的
          let splitBatchList = this.editForm.editData[0].batchNo.split(';')
          splitBatchList.map((v) => {
            this.batchList.push({
              batchNo: v
            })
          })
          this.batchShowStatus = '0'
        } else {
          this.batchShowStatus = '0'
        }
      }
      this.batchVisible = true
    },
    addBatch() {
      this.batchList.push({

      })
    },
    delBatch(row, i) {
      this.batchList.splice(i, 1)
    },
    setSelPro(val) {
      console.log('negativeIndex1111', this.negativeIndex);
      console.log('tableData1', this.tableData1);
      var arr = JSON.parse(val)
      console.log('arr', arr);
      arr.forEach(ele => {
        this.$set(ele, 'ttQspiStockRecItemId', this.negativeIndex)
        this.$set(ele, 'batchNo', '')
        this.$set(ele, 'relatedDcCode', '')
        this.$set(ele, 'relatedDcName', '')
        this.$set(ele, 'regoins', '')
        this.$set(ele, 'recoveryScope', '')
        this.$set(ele, 'recoveryScopeI18n', '')
        this.$set(ele, 'restaurantRecoveryQty', '')
        this.$set(ele, 'dcRecoveryQty', '')
        this.$set(ele, 'recoveryQty', '')
        this.$set(ele, 'handlingResult', "")
        this.$set(ele, 'handlingResultI18n', '')
        this.negativeIndex = this.negativeIndex - 1;
      })
      if (arr.length > 0) {
        for (const i in arr) {
          this.tableData1.push(arr[i])
          this.tabData1.push(arr[i])
        }
      }
      console.log('新增后数据', this.tableData1);
      console.log('negativeIndex新增后', this.negativeIndex);
      this.dialogProVisible = false
    },
    onModify(row, scope) {
      console.log("rrrrrrrrr", row)
      this.productNum++
      this.editForm.editData = []
      this.batchList = []
      this.index = scope
      this.$set(row, 'productNum', this.productNum)
      let newObj = JSON.parse(JSON.stringify(row))
      if (!newObj.packType) {
        newObj.packType = "outer"
      }
      if (!newObj.handlingResult) {
        this.$set(newObj, 'handlingResult', 'Destroy')
      }
      this.editForm.editData.push(newObj)

      if (this.editForm.editData[0].batchNo) {
        this.batchList.push({
          batchNo: this.editForm.editData[0].batchNo
        })
      }


      this.dialogEditVisible = true
    },
    onConfirm() {
      console.log('2421', this.editForm.editData);
      console.log("批次号显示=====0合并1拆分", this.batchShowStatus)
      console.log("批次号的数据====", this.batchList)

      if (!this.editForm.editData[0].batchNo) {
        this.$message.error("请选择批次号")
        return
      }
      let setNewArr = []
      if (this.batchShowStatus == '1') {
        let newArr = []
        let batchNoList = []
        this.batchList.map((v, i) => {
          let obj = {}
          obj = this.editForm.editData[0]
          newArr.push(obj)
        })
        this.batchList.map((v, i) => {
          batchNoList.push({
            ...newArr[i],
            ...v
          })
        })
        setNewArr = batchNoList
      } else {
        let newBatch = ""
        this.batchList.map((v, i) => {
          newBatch += i === this.batchList.length - 1 ? v.batchNo : v.batchNo + ';'
        })
        this.editForm.editData[0].batchNo = newBatch
        setNewArr = this.editForm.editData
      }

      if (this.batchShowStatus == '1') {  //拆分
        // this.tabData1.map((v, i) => {
        //   if (v.productNum == setNewArr[0].productNum) {
        //     this.tabData1.splice(i, 1)
        //     // this.tabData1.splice(i, 0, { name: '11' })
        //     setNewArr.map((j, k) => {
        //       this.tabData1.splice(i, 0, { name: '11' }, { name: '22' })
        //       // this.tabData1.splice(i, 0, { ...j })
        //     })
        //   }
        // })
        this.tabData1.map((v, i) => {
          if (v.productNum == setNewArr[0].productNum) {
            this.tabData1.splice(i, 1)
          }
        })
        console.log("选择的拆分的数据=====", this.tabData1)
        setNewArr.map((v) => {
          v.productNum = this.productNum++
        })
        this.tabData1 = this.tabData1.concat(setNewArr)
      } else {
        this.tabData1.map((v, i) => {
          if (v.productNum == setNewArr[0].productNum) {
            this.editForm.editData[0].productNum = this.productNum++
            this.tabData1.splice(i, 1, this.editForm.editData[0])
          }
        })
        // this.editForm.editData[0].productNum = this.productNum++
        // this.tabData1.push(this.editForm.editData[0])
      }
      this.$refs['editFormDialog'].validate((valid) => {
        if (valid) {
          // this.relatedDcCodeLists.forEach(ele => {
          //   if (ele.dcCode == this.editForm.editData[0].relatedDcCode) {
          //     this.editForm.editData[0].relatedDcName = ele.dcName
          //   }
          // })
          // this.$refs.plxTable1.reloadRow(this.$refs.plxTable1.data[this.index], this.editForm.editData[0], null)
          // console.log('this.$refs.plxTable1.data[this.index]', this.$refs.plxTable1.data);
          console.log("查看更新后的数据=====", this.tabData1)
          console.log("查看更新后的数据=====", this.editForm.editData)
          this.dialogEditVisible = false
          setTimeout(() => {
            this.editForm.editData = []
          }, 500);
        }
      })
    },
    onUpload() {
      this.dialogUploadVisible = true
      this.uploadForm = {
        fileName: "",
        files: [],
      }
    },
    getUploadUrl(id) {
      let newUrl = '/file/QUALITY_DEFECT/' + id
      return newUrl
    },
    submitUpload() {
      this.detailForm.details = this.tabData1
      StockRecoveryApi.saveQualityDefect(this.detailForm).then((res) => {
        console.log("🚀 ~ StockRecoveryApi.saveQualityDefect ~ res:", res)
        if (res.code == 200) {
          this.getDetailInfo(res.data.ttQualityDefectId)
          let formData = new FormData();
          formData.append('file', this.uploadForm.files, this.uploadForm.files.name)
          formData.append('docComments', this.uploadForm.docComments ? this.uploadForm.docComments : "")
          StockRecoveryApi.uploadQualityDefect(formData, res.data.ttQualityDefectId).then((res) => {
            var obj = Object.assign({}, this.uploadForm)
            this.$set(obj, 'documentName', res.data[0].documentName)
            this.$set(obj, 'uploadBy', res.data[0].uploadBy)
            this.$set(obj, 'fullPath', res.data[0].fullPath)
            this.$set(obj, 'createDate', res.data[0].createDate)
            this.$set(obj, 'docComments', res.data[0].docComments ? res.data[0].docComments : '')
            this.$set(obj, 'userName', res.data[0].userName)
            this.$set(obj, 'tmDocumentId', res.data[0].tmDocumentId)
            this.tabData3.push(obj)
            this.$message.success("上传成功")
            this.dialogUploadVisible = false
            console.log("🚀 ~ StockRecoveryApi.uploadQualityDefect ~ res:", res)
          })
          // this.httpRequest('/file/QUALITY_DEFECT/' + res.data.ttQualityDefectId)
          // this.$refs.upload.submit();
        }
        console.log("🚀 ~ StockRecoveryApi.saveQualityDefect ~ res:", res)
      })
    },
    onCloseFileDialog() {
      this.dialogUploadVisible = false
      this.fileList = []
    },
    beforeUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$my_message(this.$t('prompt.imageFileSize'), 'error');
      }
      return isLt50M;
    },
    httpRequest(param) {
      this.uploadForm.fileName = param.file.name
      this.uploadForm.files = param.file
    },
    uploadSuccess(response, file, fileList) {
      console.log('response', response);
      if (response.code === '200') {
        this.$message.success('上传成功')
        var obj = Object.assign({}, this.uploadForm)
        this.$set(obj, 'uploadBy', response.data[0].uploadBy)
        this.$set(obj, 'uploadTime', response.data[0].uploadTime)
        this.$set(obj, 'fullPath', response.data[0].fullPath)
        this.tabData3.push(obj)
        this.fileList = []
        this.dialogUploadVisible = false
      }
    },
    onDownload(row, index) {
      StockRecoveryApi.downloadFileByFullPath({
        fullPath: row.fullPath,
        documentName: row.documentName
      }).then((res) => {
        console.log('res', res);
        fileService.respToFile(res, row.fileName);
      })
    },
    handleChange(file, fileList) {
      // console.log('file', file);
      // console.log('fileList', fileList);
      // this.uploadForm.fileName = file.name
    },
    delFile(row, index) {
      this.$confirm('是否确认删除此附件', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log("roworowrw", row)
        if (row.tmDocumentId) {
          fileService.deleteFile(row.tmDocumentId).then((res) => {
            if (res.code === '200') {
              this.tabData3.splice(index, 1);
              // this.getFileLists()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          })
        } else {
          this.tabData3.splice(index, 1)
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    recoveryScopeChange(row, val) {
      console.log("rrrrrrrrrr", row)
      if (row.disposalScope == "Restaurant") {
        row.dcDisposalQty = ""
        row.disposalQty = ""
      }
    },
    getDisposalQty(row) {
      row.disposalQty = row.dcDisposalQty
    },
    // 回收数量(箱)=餐厅回收数量(箱)+DC回收数量(箱)
    dcRecoveryQtyChange(row, val) {
      console.log('row1', row);
      console.log('DC回收数量(箱)', val);
      if (val && row.restaurantRecoveryQty) {
        row.recoveryQty = ((((Number(val).toFixed(2)) * 100) + ((Number(row.restaurantRecoveryQty).toFixed(2)) * 100)) / 100).toFixed(2)
      } else if (val && !row.restaurantRecoveryQty) {
        row.recoveryQty = Number(val).toFixed(2)
      } else if (!val && row.restaurantRecoveryQty) {
        row.recoveryQty = Number(row.restaurantRecoveryQty).toFixed(2)
      } else {
        row.recoveryQty = ''
      }
    },
    restaurantRecoveryQtyChange(row, val) {
      console.log('row2', row);
      console.log('餐厅回收数量(箱)', val);
      if (val && row.dcRecoveryQty) {
        row.recoveryQty = ((((Number(val).toFixed(2)) * 100) + ((Number(row.dcRecoveryQty).toFixed(2)) * 100)) / 100).toFixed(2)
      } else if (val && !row.dcRecoveryQty) {
        row.recoveryQty = Number(val).toFixed(2)
      } else if (!val && row.dcRecoveryQty) {
        row.recoveryQty = Number(row.dcRecoveryQty).toFixed(2)
      } else {
        row.recoveryQty = ''
      }
    },
    onAdd() {
      this.dialogProVisible = true
    },
    // 选中的行
    selectionChange(row) {
      console.log(row)
      this.multipleSelection = row
      this.multipleSelection.map((v) => {
        this.$set(v, 'productNum', this.productNum++)
      })
      this.ttQspiStockRecItemIdLists = []
      row.forEach(ele => {
        this.ttQspiStockRecItemIdLists.push(ele.ttQspiStockRecItemId)
      })
    },
    onCopy() {
      if (this.multipleSelection.length == 0) {
        this.$my_message('请选择操作数据', 'error')
        return false
      }
      this.multipleSelection.forEach((ele, index) => {
        let newObj = JSON.parse(JSON.stringify(ele))
        if (newObj.disposalScope == "Restaurant") {
          newObj.dcDisposalQty = ""
          newObj.disposalQty = ""
        }
        this.$set(newObj, 'productNum', this.productNum++)
        this.tabData1.splice(index, 0, newObj)
      });
      this.tabData1.forEach(ele => {
        this.$set(ele, 'ttQspiStockRecItemId', this.negativeIndex)
        this.negativeIndex = this.negativeIndex - 1;
      })
      this.$refs.plxTable1.clearSelection();
      console.log('negativeIndex复制后', this.negativeIndex);
    },
    onDel() {
      if (this.multipleSelection.length == 0) {
        this.$my_message('请选择操作数据', 'error');
        return false
      }
      //您确定要删除所选记录吗？
      this.$confirm('您确定要删除所选记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        console.log("multipleSelectionmultipleSelection", this.multipleSelection)
        console.log("tabData1tabData1tabData1tabData1", this.tabData1)
        this.tabData1 = this.tabData1.filter(item => !this.multipleSelection.some(ele => ele.productNum === item.productNum));
        // this.multipleSelection.map((v)=>{

        // })
        // this.tabData1.map((v,i)=>{
        //   if(){

        //   }
        // })
        // this.multipleSelection=[]
      })
    },
    renderHeader(h, { column, $index }) {
      return h("span", [
        h("span", { class: "mandatory" }),
        h("span", column.label)
      ]);
    },
    onSave() {
      this.detailForm.details = this.tabData1
      // this.disposalQty
      StockRecoveryApi.saveQualityDefect(this.detailForm).then((res) => {
        if (res.code == 200) {
          this.$message.success('保存成功')
          this.getDetailInfo(res.data.ttQualityDefectId)
        }
        console.log("🚀 ~ StockRecoveryApi.saveQualityDefect ~ res:", res)
      })
    },
    stinvUrl() {
      window.open(this.detailForm.stinvLink, '_blank');
    },
    onSubmit(type) {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          if (this.tabData1.length == 0) {
            this.$my_message('请至少填写一行产品明细', 'error')
            return false
          }
          let flag = false;
          for (let i = 0; i < this.tabData1.length; i++) {
            const ele = this.tabData1[i];
            if (!ele.batchNo) {
              this.$my_message('第' + (i + 1) + '行,产品批次必填', 'error')
              flag = true
            }

            // if (!ele.recoveryScope) {
            //   this.$my_message('第' + (i + 1) + '行,回收范围必填', 'error')
            //   flag = true
            // }
            if (!ele.handlingResult) {
              this.$my_message('第' + (i + 1) + '行,处理结果必填', 'error')
              flag = true
            }
            // 当回收范围为餐厅或DC+餐厅时 餐厅回收数量必填 
            // if ((ele.recoveryScope === "DCAndRestaurant" || ele.recoveryScope === "Restaurant") && !ele.restaurantRecoveryQty) {
            //   this.$my_message('第' + (i + 1) + '行,餐厅回收数量必填', 'error')
            //   flag = true
            // }
            // // 当回收范围为DC或DC+餐厅时 DC回收数量必填
            // if ((ele.recoveryScope === "DCAndRestaurant" || ele.recoveryScope === "DC") && !ele.dcRecoveryQty) {
            //   this.$my_message('第' + (i + 1) + '行,DC回收数量必填', 'error')
            //   flag = true
            // }
            // var reg = /^[0-9]+(\.[0-9]{1,3})?$/
            // if (ele.restaurantRecoveryQty && !reg.test(ele.restaurantRecoveryQty)) {
            //   this.$my_message('第' + (i + 1) + '行,字段“餐厅回收数量”输入格式不满足要求（格式：数字,最多两位小数），请检查.', 'error')
            //   flag = true
            // }
            // if (ele.dcRecoveryQty && !reg.test(ele.dcRecoveryQty)) {
            //   this.$my_message('第' + (i + 1) + '行,字段“DC回收数量”输入格式不满足要求（格式：数字,最多两位小数），请检查.', 'error')
            //   flag = true
            // }
          }
          if (flag) {
            return;
          }
          console.log('this.tableData1', this.tableData1);
          // this.tableData1.forEach(ele => {
          //   if ((typeof ele.handlingResult == 'object') && ele.handlingResult.constructor == Array) {
          //     this.$set(ele, 'handlingResult', ele.handlingResult.join(','))
          //   }
          // })
          console.log('this.333', this.tableData1);
          var obj = {
            ttQualityDefectId: this.ttQualityDefectId,
            recoveryStartDate: this.detailForm.recoveryStartDate,
            recoveryProjectSummary: this.detailForm.recoveryProjectSummary,
            srGrade: this.detailForm.srGrade,
            remarks: this.detailForm.remarks,
            reason: this.detailForm.reason,
            items: this.tableData1,
            attachments: this.tableData2
          }
          if (type === 'submit') {
            this.detailForm.details = this.tabData1
            StockRecoveryApi.submitQualityDefect(this.detailForm).then(res => {
              console.log('res', res);
              if (res.code === '200') {
                this.$message.success('提交成功')
                this.$router.go(-1)
              }
            });
          }
        }
      })
    },
    madeDateRules(index, row) {
      return (this.rules["madeDate"] = [
        {
          validator: (rule, value, callback) => {
            if (!value) {
              this.$my_message('请选择生产日期', 'error')
              return callback(new Error(' '));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    dcDisposalQtyRules(index, row) {
      return (this.rules["dcDisposalQty"] = [
        {
          validator: (rule, value, callback) => {
            if (!value) {
              this.$my_message('请输入DC报废数量', 'error')
              return callback(new Error(' '));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    disposalScopeRules(index, row) {
      return (this.rules["disposalScope"] = [
        {
          validator: (rule, value, callback) => {
            if (!value) {
              this.$my_message('请选择报废范围', 'error')
              return callback(new Error(' '));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    packTypeRules(index, row) {
      return (this.rules["packType"] = [
        {
          validator: (rule, value, callback) => {
            if (!value) {
              this.$my_message('请选择包装类型', 'error')
              return callback(new Error(' '));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    restaurantRecoveryQtyRules(index, row) {
      return (this.rules["restaurantRecoveryQty"] = [
        {
          validator: (rule, value, callback) => {
            if (value) {
              var reg = /^[0-9]+(\.[0-9]{1,3})?$/
              if (!reg.test(value)) {
                this.$my_message('字段“餐厅回收数量”输入格式不满足要求（格式：数字,最多两位小数），请检查.', 'error')
                return callback(new Error(' '));
              }
              value = Number(value).toFixed(2)
              this.editForm.editData[index].restaurantRecoveryQty = value
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    dcRecoveryQtyRules(index, row) {
      return (this.rules["dcDisposalQty"] = [
        {
          validator: (rule, value, callback) => {
            if (!value) {
              this.$my_message('请输入DC报废数量', 'error')
              return callback(new Error(' '));
            }
            if (value) {
              var reg = /^[0-9]+(\.[0-9]{1,2})?$/
              if (!reg.test(value)) {
                this.$my_message('字段“DC回收数量”输入格式不满足要求（格式：数字,最多两位小数），请检查.', 'error')
                return callback(new Error(' '));
              }
              value = Number(value).toFixed(2)
              this.editForm.editData[index].dcRecoveryQty = value
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    onCancel() {
      this.dialogEditVisible = false
      this.editForm.editData = []
    },
    onCancel1() {
      this.batchVisible = false
    },
    onConfirm1() {
      console.log("批次号显示=====0合并1拆分", this.batchShowStatus)
      console.log("批次号的数据====", this.batchList)

      if (this.batchList.length == 0) {
        this.editForm.editData[0].batchNo = ""
      } else {
        if (this.batchShowStatus == '0') {
          if (this.batchList.length > 1) {
            this.editForm.editData[0].batchNo = ""
            this.batchList.map((v, i) => {
              this.editForm.editData[0].batchNo += i == this.batchList.length - 1 ? v.batchNo : v.batchNo + ';'
            })
          } else {
            this.editForm.editData[0].batchNo = ""
            this.editForm.editData[0].batchNo = this.batchList[0].batchNo
          }
          this.batchShowStatus = '0'
        } else {
          this.editForm.editData[0].batchNo = ""
          this.batchList.map((v, i) => {
            this.editForm.editData[0].batchNo += i == this.batchList.length - 1 ? v.batchNo : v.batchNo + ';'
          })
          this.batchShowStatus = '1'
        }
      }
      this.batchVisible = false
    },
    onClose() {
      this.dialogUploadVisible = false
    },
    onClosePro() {
      this.dialogProVisible = false
    },
    routerBack() {
      this.$router.go(-1)
    },
  },
}
</script>

<style scoped>
/deep/ .setLength table tbody tr td .newDcs {
  white-space: pre-line !important;
}

.stockRecovery_table .el-form-item {
  margin-bottom: 0 !important;
}

.rowCenter {
  display: flex;
  justify-content: center;
  align-content: center;
}
</style>